<script setup lang="ts" generic="T extends string">
export interface RadioGroupOption<T> {
  id: string;
  value: T;
  label: string;
}

withDefaults(
  defineProps<{
    name: string;
    modelValue: T | null | undefined;
    options: RadioGroupOption<T>[];
    disabled?: boolean;
    required?: boolean;
  }>(),
  {
    disabled: false,
    required: false,
  },
);

const emit = defineEmits<{
  'update:modelValue': [value: T];
}>();
</script>

<template>
  <label
    v-for="(option, index) in options"
    :key="option.id"
    class="radio"
    :class="{ 'mr-4': index < options.length - 1 }"
  >
    <input
      type="radio"
      :id="option.id"
      :value="option.value"
      :checked="modelValue === option.value"
      :name="name"
      :required="required"
      :disabled="disabled"
      @change="emit('update:modelValue', option.value)"
    />
    {{ option.label }}
  </label>
</template>
